import styled, { css } from 'styled-components';
import MUSICBG from '../../../static/MUSICBG.jpg';

const PLAYER_WIDTH = '300px';

export const Container = styled.div`
  display: flex;
  width: calc(${PLAYER_WIDTH} + 100vw);
  transition: all 180ms ease-out;
  transform: translateX(0);
  align-items: flex-start;
  ${({ open }) =>
    open &&
    css`
      transform: translateX(calc(-${PLAYER_WIDTH}));
    `};

  @media (max-width: 600px) {
    height: calc(100vh);
  }
`;

export const Play = styled.img`
  display: flex;
  transform: scale(0.3);
  box-shadow: none !important;
  position: absolute;
  opacity: 0.5;

  transition: all 180ms ease-out;
  ${({ isPlaying }) =>
    isPlaying &&
    css`
      opacity: 0.7;
    `} &:hover {
    opacity: 0.5;
  }
`;

export const Player = styled.div`
  width: ${PLAYER_WIDTH};
  height: 800px;
  background: black;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;

  iframe {
    height: 800px;
  }

  @media (max-width: 600px) {
    height: 100vh;
    iframe {
      height: 100vh;
    }
  }
`;

export const BG = styled.div`
  background: url(${MUSICBG}) no-repeat;
  background-size: cover;
  width: 100vw;
  height: 800px;
  background-position-x: center;
  background-position-y: middle;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  @media (max-width: 600px) {
    height: 100vh;
    padding: 20px;
  }
`;

export const CurrentAlbum = styled.div`
  width: 225px;
  position: relative;
  cursor: pointer;

  @media (max-width: 600px) {
    width: 140px;
    img {
      margin-bottom: 10px;
    }
  }

  img {
    width: 100%;
    margin-bottom: 15px;
    box-shadow: 0 6px 19px 0 rgba(0, 0, 0, 0.31);
  }

  .title {
    position: absolute;
    text-transform: uppercase;
    color: #000;
    font-size: 1.6em;
    line-height: 1.1;
    z-index: 100;
    font-family: 'GT America';
    font-weight: bold;
    font-style: italic;
    font-size: 0.85em;
    padding-left: 8px;
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: 600px) {
    flex-direction: column-reverse;
    align-items: center;

    .leftControls {
      margin-top: 20px;
      color: #000;
    }
  }

  .leftControls {
    display: flex;
    align-items: center;
  }

  .rightControls {
    display: flex;
    button {
      padding: 0;
      cursor: pointer;
      background: none;
      outline: 0;
      border: none;
      display: block;
      margin-left: 15px;
      border: 4px solid white;
      transition: all 180ms ease-out;
      box-shadow: 0 6px 19px 0 rgba(0, 0, 0, 0.31);
      img {
        display: block;
      }
      &:hover {
        border: 4px solid black;
      }

      &:first-child {
        margin-left: 0;
      }

      img {
        width: 180px;

        @media (max-width: 600px) {
          width: 120px;
        }
      }
    }
  }

  .status {
    text-transform: uppercase;
    color: #000;
    margin-right: 25px;
    font-size: 0.85em;
    font-family: 'GT America';
    font-weight: bold;
    font-style: italic;
  }

  .services {
    display: flex;

    a {
      margin-right: 15px;
      width: 30px;

      &:last-child {
        margin-right: 0;
      }
    }

    button {
      background: none;
      border: none;
      outline: none;
      display: block;
      margin-right: 15px;
      transition: all 180ms ease-out;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }

    img {
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;
